var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 710.935,
    height: 596.15,
    viewBox: "0 0 710.935 596.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.302,
    x2: 0.5,
    y2: 0.645,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c2eed3",
    stopOpacity: 0.031
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c2eed3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_6402",
    x: 424.867,
    y: 0,
    width: 192,
    height: 225,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.102
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6563",
    "data-name": "Path 6563",
    d: "M268.2,250.205l.549-11.905,65.387.183-.55,11.905Z",
    transform: "translate(-268.2 -238.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6399",
    "data-name": "Rectangle 6399",
    width: 75.278,
    height: 4.579
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6400",
    "data-name": "Rectangle 6400",
    width: 37.731,
    height: 4.579
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6401",
    "data-name": "Rectangle 6401",
    width: 52.75,
    height: 4.579
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7373",
    "data-name": "Group 7373",
    transform: "translate(-124.133 -289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Floor",
    transform: "translate(124.133 474.762)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Floor_4_",
    cx: 355.468,
    cy: 205.194,
    rx: 355.468,
    ry: 205.194,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2966",
    "data-name": "Ellipse 2966",
    cx: 65.5,
    cy: 11,
    rx: 65.5,
    ry: 11,
    transform: "translate(302 790)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 124.13, 289)",
    filter: "url(#Rectangle_6402)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6402-2",
    "data-name": "Rectangle 6402",
    width: 162,
    height: 195,
    rx: 10,
    transform: "translate(439.87 10)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character",
    transform: "translate(88.801 223.801)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6801",
    "data-name": "Group 6801",
    transform: "translate(216.545 163.473)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6749",
    "data-name": "Group 6749",
    transform: "translate(37.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6748",
    "data-name": "Group 6748"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6747",
    "data-name": "Group 6747"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6746",
    "data-name": "Group 6746"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6745",
    "data-name": "Group 6745"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6452",
    "data-name": "Path 6452",
    d: "M243.741,166.371s13.253,6.543,9.9,24.158c-3.187,17.615-4.7,19.963-1.007,26.842s8.052,36.236,4.7,41.772-40.766-24.493-45.966-49.657,3.355-36.4,6.375-40.6S232,160.5,243.741,166.371Z",
    transform: "translate(-209.722 -163.473)"
  })))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6453",
    "data-name": "Path 6453",
    d: "M228.206,423.442h3.02V409.35a38.456,38.456,0,0,1,9.562,9.395c3.691,5.368,8.724,5.033,16.441,4.53,7.717-.336,7.381-3.523,6.71-7.885s-8.556-5.7-11.072-6.375-8.22-10.569-10.066-13.085a36.8,36.8,0,0,1-3.859-6.375s-1.51-5.872-8.556,0c-7.214,5.872-5.033,17.112-4.194,18.286C226.864,408.846,228.206,423.442,228.206,423.442Z",
    transform: "translate(-161.646 -12.047)",
    fill: "#263643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6454",
    "data-name": "Path 6454",
    d: "M241.963,408.57c2.684,1.678,9.562,0,9.562,0-2.013-2.516-14.092-19.46-14.092-19.46-7.381-4.194-10.233,1.678-10.233,1.678C230.387,391.626,239.446,406.893,241.963,408.57Z",
    transform: "translate(-160.304 -11.603)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6755",
    "data-name": "Group 6755",
    transform: "translate(158.157 128.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6754",
    "data-name": "Group 6754"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6753",
    "data-name": "Group 6753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6752",
    "data-name": "Group 6752"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6455",
    "data-name": "Path 6455",
    d: "M282.271,247.837s4.865.839,6.375-1.342c1.342-1.845,4.53-3.355,5.536-3.859,1.342-.671,4.7-4.026,5.368-2.349.839,1.678-5.2,5.872-6.375,6.878-1.007,1.174,5.872,1.678,7.046,2.684,1.174,1.174-.336,12.582-5.033,11.743s-9.227-5.033-10.066-5.033a34.521,34.521,0,0,1-3.523-.5Z",
    transform: "translate(-281.6 -239.823)",
    fill: "#dba585"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6759",
    "data-name": "Group 6759",
    transform: "translate(172.082 137.777)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6758",
    "data-name": "Group 6758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6757",
    "data-name": "Group 6757"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6756",
    "data-name": "Group 6756"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6456",
    "data-name": "Path 6456",
    d: "M293.758,245.6s14.427,3.691,15.1,4.7.5,1.845-.839,1.51-13.924-3.187-13.924-3.187,16.273,7.214,17.112,7.885c.5.5,0,2.013-.671,1.845s-17.279-6.375-17.279-6.375,15.1,6.71,15.6,7.549c.5.671-.336,2.013-1.51,1.51s-15.6-5.872-15.6-5.872,10.737,5.7,10.737,6.543c0,.5-.336,1.845-3.02.335s-9.562-4.529-9.562-4.529Z",
    transform: "translate(-289.9 -245.6)",
    fill: "#dba585"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6457",
    "data-name": "Path 6457",
    d: "M204.291,419.848h1.845v-10.4a20.539,20.539,0,0,1,4.7,8.388c1.51,5.033,6.878,6.375,15.1,6.207s8.22-3.523,7.549-8.388-7.549-7.381-7.549-7.381c-3.187-2.684-10.9-14.26-10.9-14.26s-5.033-1.342-8.891,1.845-2.684,10.233-2.516,12.079S204.291,419.848,204.291,419.848Z",
    transform: "translate(-176.484 -7.447)",
    fill: "#263643"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6459",
    "data-name": "Path 6459",
    d: "M250.034,266.185s16.105,61.233,17.95,69.621c1.845,8.556,4.7,15.434,4.7,19.125,0,8.388-3.02,21.809-3.02,21.809l-20.3,97.3H229.9s10.737-58.381,11.072-69.788,9.059-27.68,7.381-32.546-27.848-60.729-27.848-60.729S200.544,248.4,250.034,266.185Z",
    transform: "translate(-167.536 -96.03)",
    fill: "#2c3a3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6458",
    "data-name": "Path 6458",
    d: "M213.978,263.544s-9.73,12.75-12.414,27.68c-2.684,15.1,1.51,65.594,1.51,72.976-.168,7.381-7.046,26-5.7,39.927,1.342,14.092,6.878,83.712,6.878,83.712l14.931-3.02s-.839-71.13,0-77,2.684-27.345,3.02-29.694,21.977-65.93,21.977-76.834C244.175,290.553,237.633,245.929,213.978,263.544Z",
    transform: "translate(-180.635 -98.421)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6460",
    "data-name": "Path 6460",
    d: "M224.8,408.16l-10.9-14.26L205,395.745a39.8,39.8,0,0,0,6.71,11.24C216.911,412.689,224.8,408.16,224.8,408.16Z",
    transform: "translate(-175.347 -7.334)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6765",
    "data-name": "Group 6765",
    transform: "translate(69.989 66.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6764",
    "data-name": "Group 6764"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6461",
    "data-name": "Path 6461",
    d: "M234.842,202.9a20.273,20.273,0,0,1,11.575,6.039,70.184,70.184,0,0,1,10.9,16.776c1.342,2.852,19.628,29.358,20.634,29.861,1.007.671,10.233,3.691,16.273,5.7,9.395,3.187,28.352,10.066,28.352,10.066l-3.691,11.911s-35.565-11.576-44.457-13.756c-10.9-2.684-35.9-34.726-35.9-34.726S219.911,212.63,234.842,202.9Z",
    transform: "translate(-229.044 -202.9)",
    fill: "#ed7d2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6767",
    "data-name": "Group 6767",
    transform: "translate(18.245 61.139)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6766",
    "data-name": "Group 6766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6462",
    "data-name": "Path 6462",
    d: "M244.166,200.392s8.556,4.026,11.575,4.7,14.427,15.6,16.608,20.97c2.013,5.536,0,13.589-4.194,23.319-4.194,9.562-.168,12.918-2.181,22.48-1.845,9.562-1.342,45.631-1.007,51s-55.7,13.421-66.769,3.691c0,0,7.549-32.546,16.273-41.772,1.845-2.013,1.678-15.434.336-18.621C213.466,262.8,198.7,237.97,198.7,237.97s-1.007-25.164,5.368-30.2c5.536-4.362,20.8-5.872,23.486-6.878C230.746,199.889,238.63,199.553,244.166,200.392Z",
    transform: "translate(-198.2 -199.917)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6769",
    "data-name": "Group 6769",
    transform: "translate(48.107 39.989)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6768",
    "data-name": "Group 6768"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6463",
    "data-name": "Path 6463",
    d: "M236.3,199.037s-.336,2.349-.5,5.536c-.168,1.342-.168,2.684-.336,4.026a98.937,98.937,0,0,0-.5,11.24s-8.891,8.891-18.957-10.4c0,0,4.194-7.885,1.007-18.789S236.3,199.037,236.3,199.037Z",
    transform: "translate(-216 -187.309)",
    fill: "#ffbe9d"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6770",
    "data-name": "Group 6770",
    transform: "translate(89.04 91.14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6464",
    "data-name": "Path 6464",
    d: "M244.594,240.783s2.181-14.26-.168-22.983c0,0,0,7.381-4.026,17.95Z",
    transform: "translate(-240.4 -217.8)",
    fill: "#d86200"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6771",
    "data-name": "Group 6771",
    transform: "translate(41.228 61.782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6465",
    "data-name": "Path 6465",
    d: "M211.9,201.978s6.039,18.118,22.983,16.776c16.776-1.342,7.885-15.266,7.885-15.266A52.2,52.2,0,0,0,237.4,200.8c-1.174-.168-18.621-.5-18.621-.5Z",
    transform: "translate(-211.9 -200.3)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6772",
    "data-name": "Group 6772",
    transform: "translate(72.096 64.969)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6466",
    "data-name": "Path 6466",
    d: "M230.3,202.2s8.724,24.325,8.724,49.154.671,65.259,3.858,78.009c3.02,12.75,11.743,52.174,11.743,52.174l6.878-3.523s-16.441-62.91-17.783-67.607c-1.174-4.53,1.007-52.509,2.181-56.535s6.207-21.977,5.368-26.842c-1.007-6.207-6.878-15.434-16.273-23.486Z",
    transform: "translate(-230.3 -202.2)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6773",
    "data-name": "Group 6773",
    transform: "translate(7.173 62.621)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6467",
    "data-name": "Path 6467",
    d: "M228.843,200.8a241.29,241.29,0,0,1,8.22,39.927c2.852,22.48-8.556,126.491-16.105,150.146l-29.358-4.7s6.375-73.647,14.931-86.9c8.556-13.421,11.24-25.164,2.013-53.18s4.026-41.772,4.026-41.772S226.326,201.135,228.843,200.8Z",
    transform: "translate(-191.6 -200.8)",
    fill: "#f99746"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6774",
    "data-name": "Group 6774",
    transform: "translate(1.134 113.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6468",
    "data-name": "Path 6468",
    d: "M262.989,254.654l-35.565,61.568L188,293.407,221.888,231Z",
    transform: "translate(-188 -231)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6775",
    "data-name": "Group 6775",
    transform: "translate(5.16 117.982)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6469",
    "data-name": "Path 6469",
    d: "M257,254.938,225.462,309.46,190.4,289.329,220.6,233.8Z",
    transform: "translate(-190.4 -233.8)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6776",
    "data-name": "Group 6776",
    transform: "translate(45.422 122.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6470",
    "data-name": "Path 6470",
    d: "M229.163,248.211l2.181-3.858L217.252,236.3l-2.852,3.523Z",
    transform: "translate(-214.4 -236.3)",
    fill: "#333"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6782",
    "data-name": "Group 6782",
    transform: "translate(42.067 158.747)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6781",
    "data-name": "Group 6781"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6780",
    "data-name": "Group 6780"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6779",
    "data-name": "Group 6779"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6778",
    "data-name": "Group 6778"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6777",
    "data-name": "Group 6777"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6471",
    "data-name": "Path 6471",
    d: "M228.84,277.225a7.557,7.557,0,0,1-2.349-.336s-1.174-.671-2.181-1.174c-.335-.168-.5-.336-.671-.336a11.213,11.213,0,0,1-4.026-1.678c-1.51-1.007-7.214-7.549-7.214-7.549l2.684-4.026,1.845-4.026s11.743.671,13.253,1.678c.168,0,.336.168.5.336,1.342.839,1.845,2.013,2.516,2.516.168.168,2.349,2.181,2.181,3.188a2.974,2.974,0,0,1-1.342,2.349,7.355,7.355,0,0,1-1.51,3.523,4.262,4.262,0,0,1-2.013,3.187C230.518,274.708,230.183,276.889,228.84,277.225Z",
    transform: "translate(-212.4 -258.1)",
    fill: "#ffbe9d"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6784",
    "data-name": "Group 6784",
    transform: "translate(0 65.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6783",
    "data-name": "Group 6783"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6472",
    "data-name": "Path 6472",
    d: "M221.674,203.041s-10.737-3.02-16.944,8.724c-6.207,11.911-6.207,16.944-7.046,22.815-.839,5.536-4.362,20.467-4.7,21.977s-8.388,19.963-4.7,26.338c3.691,6.543,41.1,25.5,40.766,27.009-.168,1.51,6.543-14.427,6.543-14.427s-15.1-8.388-17.615-11.072c-4.026-4.194-12.582-8.724-10.737-13.924,2.013-6.207,8.22-26.842,9.562-29.861C218.319,237.767,230.9,206.9,221.674,203.041Z",
    transform: "translate(-187.324 -202.692)",
    fill: "#ed7d2b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6789",
    "data-name": "Group 6789",
    transform: "translate(44.369 4.321)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6788",
    "data-name": "Group 6788"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6787",
    "data-name": "Group 6787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6786",
    "data-name": "Group 6786"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6785",
    "data-name": "Group 6785"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6473",
    "data-name": "Path 6473",
    d: "M239.151,166.638s19.292,6.039,8.724,39.256c-10.4,33.217-36.74-3.858-33.888-23.99C216.671,161.438,239.151,166.638,239.151,166.638Z",
    transform: "translate(-213.772 -166.048)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6794",
    "data-name": "Group 6794",
    transform: "translate(42.953 1.628)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6793",
    "data-name": "Group 6793"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6792",
    "data-name": "Group 6792"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6791",
    "data-name": "Group 6791"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6790",
    "data-name": "Group 6790"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6474",
    "data-name": "Path 6474",
    d: "M250.459,187.018a43.333,43.333,0,0,1-25.5,10.569s-6.207,7.214-6.543,10.066c0,0-14.26-24.325,3.187-38.92S256.834,180.979,250.459,187.018Z",
    transform: "translate(-212.928 -164.443)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6799",
    "data-name": "Group 6799",
    transform: "translate(48.498 28.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6798",
    "data-name": "Group 6798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6797",
    "data-name": "Group 6797"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6796",
    "data-name": "Group 6796"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6795",
    "data-name": "Group 6795"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6475",
    "data-name": "Path 6475",
    d: "M222.888,187.279c-.168-2.349-1.678-7.885-5.2-6.375s.168,12.75,2.516,12.079C220.2,192.815,223.056,192.983,222.888,187.279Z",
    transform: "translate(-216.233 -180.647)",
    fill: "#ffbe9d"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6800",
    "data-name": "Group 6800",
    transform: "translate(53.307 48.193)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6476",
    "data-name": "Path 6476",
    d: "M233.527,201.259c-.168,1.342-.168,2.684-.336,4.026,0,0-8.556-.5-14.092-13.085C219.436,192.7,225.643,201.762,233.527,201.259Z",
    transform: "translate(-219.1 -192.2)",
    fill: "#997761"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6828",
    "data-name": "Group 6828",
    transform: "translate(144.2 240.093)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6803",
    "data-name": "Group 6803",
    transform: "translate(0 178.477)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6477",
    "data-name": "Path 6477",
    d: "M166.881,442.472s8.388-18.118-1.174-36.069-12.247-22.144-6.207-25.667c6.039-3.691,8.891,14.26,8.891,14.26s5.033-12.414.839-25.332-6.878-34.055-1.174-36.236,1.174,26.338,6.039,36.069c0,0,4.194-10.9,4.865-21.138.671-10.4-.336-27.009,4.194-31.2s7.381-1.342,3.02,21.641a228.82,228.82,0,0,0-4.362,41.6s9.9-30.029,16.441-30.868,6.543,8.891,1.007,17.279c-5.7,8.388-16.608,23.654-18.454,31.371,0,0,10.9-22.648,20.635-15.769s-8.556,20.635-16.608,25.5-13.756,35.9-13.756,35.9Z",
    transform: "translate(-136.013 -315.533)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6478",
    "data-name": "Path 6478",
    d: "M166.881,442.472s8.388-18.118-1.174-36.069-12.247-22.144-6.207-25.667c6.039-3.691,8.891,14.26,8.891,14.26s5.033-12.414.839-25.332-6.878-34.055-1.174-36.236,1.174,26.338,6.039,36.069c0,0,4.194-10.9,4.865-21.138.671-10.4-.336-27.009,4.194-31.2s7.381-1.342,3.02,21.641a228.82,228.82,0,0,0-4.362,41.6s9.9-30.029,16.441-30.868,6.543,8.891,1.007,17.279c-5.7,8.388-16.608,23.654-18.454,31.371,0,0,10.9-22.648,20.635-15.769s-8.556,20.635-16.608,25.5-13.756,35.9-13.756,35.9Z",
    transform: "translate(-136.013 -315.533)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6479",
    "data-name": "Path 6479",
    d: "M181.352,447.136s-8.053-18.286,1.678-35.9c9.73-17.783,12.582-21.977,6.543-25.667s-9.059,14.092-9.059,14.092-5.033-12.414-.5-25.332c4.362-12.918,7.214-33.888,1.51-36.236s-1.342,26.171-6.543,35.9c0,0-4.026-10.9-4.7-21.306-.5-10.4.671-27.009-3.858-31.2-4.53-4.362-7.381-1.342-3.187,21.641a234.464,234.464,0,0,1,3.859,41.6s-9.562-30.2-16.105-31.2-6.71,8.724-1.174,17.279,16.273,23.822,17.95,31.707c0,0-10.569-22.815-20.3-15.937-9.9,6.71,8.22,20.8,16.273,25.835s13.253,36.068,13.253,36.068Z",
    transform: "translate(-143.942 -312.648)",
    fill: "#36c96d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6802",
    "data-name": "Group 6802",
    transform: "translate(0 121.402)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6480",
    "data-name": "Path 6480",
    d: "M144.2,387.9h66.936l-5.368,47.812H149.736Z",
    transform: "translate(-144.2 -387.9)",
    fill: "#263238"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6805",
    "data-name": "Group 6805",
    transform: "translate(188.191 32.102)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6481",
    "data-name": "Path 6481",
    d: "M279.891,301.982h44.324v-1.648H314.141a2.774,2.774,0,0,1-2.747-2.381L307,271.212l-.916-5.312h-15.2l-13.554,32.053A2.805,2.805,0,0,0,279.891,301.982Z",
    transform: "translate(-241.393 -205.824)",
    fill: "#3a454b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6482",
    "data-name": "Path 6482",
    d: "M279.891,301.982h44.324v-1.648H314.141a2.774,2.774,0,0,1-2.747-2.381L307,271.212l-.916-5.312h-15.2l-13.554,32.053A2.805,2.805,0,0,0,279.891,301.982Z",
    transform: "translate(-241.393 -205.824)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6483",
    "data-name": "Path 6483",
    d: "M279.034,297.922h34.434a2.774,2.774,0,0,1-2.747-2.381l-4.4-26.741H290.39L278.3,296.457A.883.883,0,0,0,279.034,297.922Z",
    transform: "translate(-240.536 -203.412)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6804",
    "data-name": "Group 6804",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6484",
    "data-name": "Path 6484",
    d: "M272.269,303.067h88.648a1.285,1.285,0,0,0,1.282-1.648l-12.638-66.67a2.121,2.121,0,0,0-1.832-1.648H258.9a1.285,1.285,0,0,0-1.282,1.648l12.638,66.67A2.146,2.146,0,0,0,272.269,303.067Z",
    transform: "translate(-257.581 -233.1)",
    fill: "#8b9296"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6485",
    "data-name": "Path 6485",
    d: "M272.269,303.067h88.648a1.285,1.285,0,0,0,1.282-1.648l-12.638-66.67a2.121,2.121,0,0,0-1.832-1.648H258.9a1.285,1.285,0,0,0-1.282,1.648l12.638,66.67A2.146,2.146,0,0,0,272.269,303.067Z",
    transform: "translate(-257.581 -233.1)",
    fill: "#fff",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6486",
    "data-name": "Path 6486",
    d: "M273.269,303.067h88.649a1.285,1.285,0,0,0,1.282-1.648l-12.638-66.67a2.121,2.121,0,0,0-1.832-1.648H259.9a1.285,1.285,0,0,0-1.282,1.648l12.638,66.67A2.146,2.146,0,0,0,273.269,303.067Z",
    transform: "translate(-256.749 -233.1)",
    fill: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6487",
    "data-name": "Path 6487",
    d: "M272.522,297.125h84.985L345.785,235.4H260.8Z",
    transform: "translate(-254.904 -231.187)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6806",
    "data-name": "Group 6806",
    transform: "translate(245.098 120.041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6488",
    "data-name": "Path 6488",
    d: "M387.1,288.92v-1.845L355.727,280.7H294.494a4.153,4.153,0,0,0-4.194,4.194h0a4.153,4.153,0,0,0,4.194,4.194Z",
    transform: "translate(-290.3 -280.7)",
    fill: "#4e4e4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6489",
    "data-name": "Path 6489",
    d: "M290.4,284.894a4.047,4.047,0,0,0,1.174,2.852,4.378,4.378,0,0,0,2.852,1.174h92.6v-1.845L355.659,280.7H294.426A4.12,4.12,0,0,0,290.4,284.894Z",
    transform: "translate(-290.232 -280.7)",
    fill: "#141414",
    opacity: 0.22
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6490",
    "data-name": "Path 6490",
    d: "M290.4,284.894a4.047,4.047,0,0,0,1.174,2.852,4.378,4.378,0,0,0,2.852,1.174h37.243v-1.845L300.3,280.7h-5.872A4.12,4.12,0,0,0,290.4,284.894Z",
    transform: "translate(-290.232 -280.7)",
    fill: "#fff",
    opacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6813",
    "data-name": "Group 6813",
    transform: "translate(113.909 128.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6807",
    "data-name": "Group 6807",
    transform: "translate(85.558 9.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6491",
    "data-name": "Path 6491",
    d: "M286.419,501.033h-8.388L263.1,291.5h11.072Z",
    transform: "translate(-263.1 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6492",
    "data-name": "Path 6492",
    d: "M286.419,500.9h-8.388l-14.26-199.132L263.1,291.7h11.072l.671,10.066Z",
    transform: "translate(-263.1 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6493",
    "data-name": "Path 6493",
    d: "M274.843,301.262H263.771L263.1,291.7h11.072Z",
    transform: "translate(-263.1 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6808",
    "data-name": "Group 6808",
    transform: "translate(160.715 9.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6494",
    "data-name": "Path 6494",
    d: "M317.63,501.033h-8.388L307.9,291.5h11.072Z",
    transform: "translate(-307.9 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6495",
    "data-name": "Path 6495",
    d: "M318.972,291.7l-.168,33.72L317.63,500.9h-8.388L308.068,325.42,307.9,291.7Z",
    transform: "translate(-307.9 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6496",
    "data-name": "Path 6496",
    d: "M318.972,291.7l-.168,34.223H308.068L307.9,291.7Z",
    transform: "translate(-307.9 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6809",
    "data-name": "Group 6809",
    transform: "translate(236.039 9.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6497",
    "data-name": "Path 6497",
    d: "M376.119,501.033h-8.388L352.8,291.5h11.072Z",
    transform: "translate(-352.8 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6498",
    "data-name": "Path 6498",
    d: "M376.119,500.9h-8.388l-14.26-199.132L352.8,291.7h11.072l.5,10.066Z",
    transform: "translate(-352.8 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6499",
    "data-name": "Path 6499",
    d: "M364.375,301.262h-10.9L352.8,291.7h11.072Z",
    transform: "translate(-352.8 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6810",
    "data-name": "Group 6810",
    transform: "translate(4.697 9.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6500",
    "data-name": "Path 6500",
    d: "M223.288,501.033H214.9L227.146,291.5h11.24Z",
    transform: "translate(-214.9 -291.5)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6501",
    "data-name": "Path 6501",
    d: "M238.386,291.7l-.839,10.066L223.288,500.9H214.9l11.743-199.132.5-10.066Z",
    transform: "translate(-214.9 -291.365)",
    fill: "#fff",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6502",
    "data-name": "Path 6502",
    d: "M222.4,291.7h11.24l-.839,9.562H221.9Z",
    transform: "translate(-210.157 -291.365)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6811",
    "data-name": "Group 6811",
    transform: "translate(8.22 4.529)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6503",
    "data-name": "Path 6503",
    d: "M461.091,298.869h-240.4A3.723,3.723,0,0,1,217,295.178V288.3H464.614v6.878A3.582,3.582,0,0,1,461.091,298.869Z",
    transform: "translate(-217 -288.3)",
    fill: "#40474c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6504",
    "data-name": "Path 6504",
    d: "M461.091,298.869h-240.4A3.723,3.723,0,0,1,217,295.178V288.3H464.614v6.878A3.582,3.582,0,0,1,461.091,298.869Z",
    transform: "translate(-217 -288.3)",
    fill: "#fff",
    opacity: 0.08
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6396",
    "data-name": "Rectangle 6396",
    width: 247.614,
    height: 5.201,
    transform: "translate(8.22 4.529)",
    fill: "#31373c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6812",
    "data-name": "Group 6812"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6505",
    "data-name": "Path 6505",
    d: "M473.135,291.639H215.12a3.007,3.007,0,0,1-3.02-3.02h0a3.007,3.007,0,0,1,3.02-3.02H473.135a3.007,3.007,0,0,1,3.02,3.02h0A3.007,3.007,0,0,1,473.135,291.639Z",
    transform: "translate(-212.1 -285.6)",
    fill: "#3a454b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__1_",
    transform: "translate(265.456)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6506",
    "data-name": "Path 6506",
    d: "M369.991,279.16l-11.743,1.678a39.732,39.732,0,0,0-8.22-1.678,71.771,71.771,0,0,0-9.059,0s-5.368,2.013-5.368,7.046c0,0,12.414,3.355,17.112,1.342l17.112-1.342V279.16Z",
    transform: "translate(-279.962 -161.804)",
    fill: "#e4897b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6507",
    "data-name": "Path 6507",
    d: "M369.991,279.16l-11.743,1.678a39.732,39.732,0,0,0-8.22-1.678,71.771,71.771,0,0,0-9.059,0s-5.368,2.013-5.368,7.046c0,0,12.414,3.355,17.112,1.342l17.112-1.342V279.16Z",
    transform: "translate(-279.962 -161.804)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6815",
    "data-name": "Group 6815",
    transform: "translate(53.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6814",
    "data-name": "Group 6814",
    transform: "translate(0 29.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6508",
    "data-name": "Path 6508",
    d: "M339.242,231.8a34.1,34.1,0,0,1-1.342,7.046,3.7,3.7,0,0,0,4.026,0Z",
    transform: "translate(-331.861 -222.945)",
    fill: "#ff9a6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6509",
    "data-name": "Path 6509",
    d: "M336.123,230.779c.5,1.007,1.174,1.845,1.845,1.51.5-.168.671-1.342.168-2.349s-1.174-1.845-1.845-1.51A1.9,1.9,0,0,0,336.123,230.779Z",
    transform: "translate(-333.271 -225.28)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6510",
    "data-name": "Path 6510",
    d: "M334.3,227.659s3.523-2.181,6.543-.5",
    transform: "translate(-334.3 -226.522)",
    fill: "none",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.725
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6511",
    "data-name": "Path 6511",
    d: "M344.1,253.389a9.592,9.592,0,0,0,1.174,1.342,17.51,17.51,0,0,0,8.724,4.865,12.948,12.948,0,0,0,2.516.336,14.922,14.922,0,0,0,12.079-4.865,16.028,16.028,0,0,0,3.187-5.2c3.02-8.052,0-14.427-4.362-25.5a17.576,17.576,0,0,0-4.194-6.375,16.267,16.267,0,0,0-23.151.839C331.346,227.889,337.218,244.665,344.1,253.389Z",
    transform: "translate(-333.359 -206.156)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6512",
    "data-name": "Path 6512",
    d: "M346.6,243.881a12.951,12.951,0,0,0,2.516.336,14.922,14.922,0,0,0,12.079-4.865A20.671,20.671,0,0,0,357.5,236.5S350.626,238.513,346.6,243.881Z",
    transform: "translate(-325.965 -190.61)",
    fill: "#ff9a6c",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6513",
    "data-name": "Path 6513",
    d: "M380.432,252.651c-1.174,7.885-18.286,10.737-18.286,10.737s-8.556,3.859-8.891.5c3.523-4.026,3.859-7.549,2.684-10.737a14.458,14.458,0,0,0-3.523-5.033c-.839-.839-1.678-1.51-2.516-2.349l5.2-21.473C359.127,232.52,372.044,251.477,380.432,252.651Z",
    transform: "translate(-323.729 -198.876)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6514",
    "data-name": "Path 6514",
    d: "M341.777,215.612s-3.691-.5-6.543,6.375c-2.349,5.7,3.188,7.046,3.02,13.085-.168,6.207,5.368,9.562,5.368,9.562s4.7,4.026,8.724,1.845c0,0,5.2,2.516,6.543,7.046s9.562-3.691,16.776-2.349c0,0,4.865-4.7,4.53-15.769a37.64,37.64,0,0,0-3.523-14.092s-2.181-6.71-10.4-10.4C357.882,207.056,343.287,209.908,341.777,215.612Z",
    transform: "translate(-334.06 -209.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6515",
    "data-name": "Path 6515",
    d: "M349.08,231.726a7.631,7.631,0,0,1-1.51,6.543c-1.845,2.013-4.7-.5-5.872-3.859-1.007-3.02-1.342-7.717,1.342-8.388C345.725,225.519,348.577,228.539,349.08,231.726Z",
    transform: "translate(-329.788 -197.747)",
    fill: "#ffbe9d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6816",
    "data-name": "Group 6816",
    transform: "translate(70.904 52.726)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6516",
    "data-name": "Path 6516",
    d: "M344.7,248c2.349,6.71,4.53,13.085,6.375,19.292,1.174,3.858,2.349,7.549,3.355,11.24.839,3.02,1.678,6.039,2.349,8.891l1.007,4.026q2.768,11.072,4.53,20.131a266.423,266.423,0,0,1,4.362,28.351l65.93-8.22c-2.349-11.24-4.026-21.138-6.543-31.874-1.342-5.872-3.02-11.911-5.033-18.621-1.342-4.865-3.02-9.9-5.033-15.434-3.187-9.059-6.207-15.1-8.556-18.789a13.375,13.375,0,0,0-10.233-6.207C373.052,239.107,344.7,248,344.7,248Z",
    transform: "translate(-344.7 -240.574)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6517",
    "data-name": "Path 6517",
    d: "M345.491,279.89l-11.743,1.678a39.727,39.727,0,0,0-8.22-1.678,47.917,47.917,0,0,0-9.059,0s-5.368,2.013-5.368,7.046c0,0,12.414,3.355,17.112,1.342l17.112-1.342V279.89Z",
    transform: "translate(-296.564 -161.36)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6817",
    "data-name": "Group 6817",
    transform: "translate(103.281 307.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6518",
    "data-name": "Path 6518",
    d: "M382.454,420.484l-12.246.168L364,392.468l12.246-.168Z",
    transform: "translate(-364 -392.3)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6519",
    "data-name": "Path 6519",
    d: "M376.246,392.3,364,392.468l3.523,16.1,12.079-.839Z",
    transform: "translate(-364 -392.3)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6520",
    "data-name": "Path 6520",
    d: "M355.832,407.608a385.259,385.259,0,0,0,17.783,52.677l22.312-1.678s-9.227-35.9-12.582-68.614c-2.013-20.3-1.845-37.075,4.026-38.417,3.691-.839,12.414-.839,23.654-.5V309.3c-31.371,6.375-62.742,18.621-65.091,28.352C342.914,351.408,348.618,380.43,355.832,407.608Z",
    transform: "translate(-273.52 -141.28)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6818",
    "data-name": "Group 6818",
    transform: "translate(94.39 307.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6521",
    "data-name": "Path 6521",
    d: "M389.232,403.372l-26.674,1.678L358.7,393.642l29.358-1.342Z",
    transform: "translate(-358.7 -392.3)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6522",
    "data-name": "Path 6522",
    d: "M389.232,403.372l-26.674,1.678L358.7,393.642l29.358-1.342Z",
    transform: "translate(-358.7 -392.3)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6819",
    "data-name": "Group 6819",
    transform: "translate(100.87 329.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6523",
    "data-name": "Path 6523",
    d: "M369.336,411h0c0-.168-.168-3.691-1.51-4.865a1.807,1.807,0,0,0-1.342-.336,1.082,1.082,0,0,0-1.007,1.007c-.168.839.5,1.845,1.174,2.852-1.174-.5-2.684-1.007-3.355-.671a1.675,1.675,0,0,0-.671.839,1.353,1.353,0,0,0,.5,1.51,2.912,2.912,0,0,0,2.349.5,21.575,21.575,0,0,0,3.187-.671h.168V411s.335,0,.335-.168c-.168.168.168.168.168.168Zm-3.523-4.026q0-.252.5-.5h.168a1.009,1.009,0,0,1,.671.168c.839.671,1.007,2.516,1.007,3.691l-.168-.168C366.987,409.323,365.813,407.645,365.813,406.974ZM363.464,411a1.233,1.233,0,0,1-.336-1.007.361.361,0,0,1,.336-.336c.839-.336,2.852.5,4.362,1.342C365.645,411.5,363.967,411.5,363.464,411Z",
    transform: "translate(-362.563 -405.8)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6524",
    "data-name": "Path 6524",
    d: "M374.384,408.339l13.756-.839a1.063,1.063,0,0,1,1.007.839h0l1.342,10.9a2.352,2.352,0,0,1-2.013,2.349c-4.865.168-7.046.168-13.085.336-3.691.168-11.072,1.007-16.1.5s-4.53-5.536-2.349-5.7c5.2-.671,12.246-4.53,15.434-7.381A2.622,2.622,0,0,1,374.384,408.339Z",
    transform: "translate(-266.573 -74.739)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6525",
    "data-name": "Path 6525",
    d: "M355.8,407.608c8.388-5.368,18.118-11.575,27.68-17.615-2.013-20.3-1.845-37.075,4.026-38.417,3.691-.839,12.414-.839,23.654-.5V309.3c-31.371,6.375-62.742,18.621-65.091,28.352C342.878,351.408,348.582,380.43,355.8,407.608Z",
    transform: "translate(-273.484 -141.28)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6820",
    "data-name": "Group 6820",
    transform: "translate(31.648 307.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6526",
    "data-name": "Path 6526",
    d: "M339.586,420.484l-12.247.168L321.3,392.468l12.247-.168Z",
    transform: "translate(-321.3 -392.3)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6527",
    "data-name": "Path 6527",
    d: "M333.547,392.3l-12.247.168,3.523,16.1,12.079-.839Z",
    transform: "translate(-321.3 -392.3)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6528",
    "data-name": "Path 6528",
    d: "M396.993,317.438l-2.013-15.769L459.064,291.1s20.97,41.437,10.737,61.9c-9.395,18.621-109.548,7.549-124.982,10.9-15.6,3.355,8.388,107.031,8.388,107.031L330.9,472.617s-34.559-93.275-27.513-122.633C306.57,337.234,359.247,320.29,396.993,317.438Z",
    transform: "translate(-302.435 -153.612)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6821",
    "data-name": "Group 6821",
    transform: "translate(22.589 307.261)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6529",
    "data-name": "Path 6529",
    d: "M346.432,403.372l-26.506,1.678L315.9,393.642l29.358-1.342Z",
    transform: "translate(-315.9 -392.3)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6530",
    "data-name": "Path 6530",
    d: "M346.432,403.372l-26.506,1.678L315.9,393.642l29.358-1.342Z",
    transform: "translate(-315.9 -392.3)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6822",
    "data-name": "Group 6822",
    transform: "translate(29.068 329.909)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6531",
    "data-name": "Path 6531",
    d: "M326.536,411h0c0-.168-.168-3.691-1.51-4.865a1.807,1.807,0,0,0-1.342-.336,1.083,1.083,0,0,0-1.007,1.007c-.168.839.5,1.845,1.174,2.852-1.174-.5-2.684-1.007-3.355-.671a1.675,1.675,0,0,0-.671.839,1.353,1.353,0,0,0,.5,1.51,2.911,2.911,0,0,0,2.349.5,21.575,21.575,0,0,0,3.188-.671h.168V411s.336,0,.336-.168a.164.164,0,0,0,.168.168Zm-3.355-4.026q0-.252.5-.5h.168a1.008,1.008,0,0,1,.671.168c.839.671,1.007,2.516,1.007,3.691l-.168-.168A5.72,5.72,0,0,1,323.181,406.974ZM320.664,411a1.232,1.232,0,0,1-.336-1.007.361.361,0,0,1,.336-.336c.839-.336,2.852.5,4.362,1.342C323.013,411.5,321.335,411.5,320.664,411Z",
    transform: "translate(-319.762 -405.8)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6532",
    "data-name": "Path 6532",
    d: "M331.684,408.339l13.756-.839a1.063,1.063,0,0,1,1.007.839h0l1.342,10.9a2.352,2.352,0,0,1-2.013,2.349c-4.865.168-7.046.168-13.085.336-3.691.168-11.072,1.007-16.105.5s-4.53-5.536-2.349-5.7c5.2-.671,12.246-4.53,15.434-7.381A2.622,2.622,0,0,1,331.684,408.339Z",
    transform: "translate(-295.506 -74.739)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6823",
    "data-name": "Group 6823",
    transform: "translate(93.048 139.836)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6533",
    "data-name": "Path 6533",
    d: "M409.6,297.365l-29.694,3.859-1.007-4.362,29.694-4.362Z",
    transform: "translate(-343.67 -292.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6534",
    "data-name": "Path 6534",
    d: "M388.309,295.1l.5,4.362L361.3,303.32v-4.362Z",
    transform: "translate(-355.596 -290.738)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6535",
    "data-name": "Path 6535",
    d: "M361.926,297.5v4.194l-4.026.5v-4.026Z",
    transform: "translate(-357.9 -289.112)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6536",
    "data-name": "Path 6536",
    d: "M348.5,258.33c1.174,3.858,2.349,7.549,3.355,11.24.839,3.02,1.678,6.039,2.349,8.891,2.013-11.24-1.678-24.661-1.678-24.661Z",
    transform: "translate(-271.221 -178.887)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6537",
    "data-name": "Path 6537",
    d: "M358.32,245c-5.368,1.007-7.046,42.611-7.381,47.141-.168,4.362-26.338,13.085-26.338,13.085v6.039s27.848-2.013,34.391-4.7,8.052-41.269,8.052-41.269Z",
    transform: "translate(-287.416 -184.85)",
    fill: "#ffbe9d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6538",
    "data-name": "Path 6538",
    d: "M347.681,245c-4.865,1.51-7.381,29.023-7.381,29.023l15.266,6.039,3.691-15.266s1.007-3.02-1.007-9.562C355.231,245.839,347.681,245,347.681,245Z",
    transform: "translate(-276.778 -184.85)",
    fill: "#36c96d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6827",
    "data-name": "Group 6827",
    transform: "translate(311.196 46.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6539",
    "data-name": "Path 6539",
    d: "M332.1,346.9H479.9v-7.046A13.175,13.175,0,0,0,466.644,326.6H345.353A13.175,13.175,0,0,0,332.1,339.853Z",
    transform: "translate(-328.074 -176.119)",
    fill: "#555d60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6540",
    "data-name": "Path 6540",
    d: "M424.3,296.5H342.932a6.6,6.6,0,0,0-6.375,8.052l14.6,62.91h3.355l-12.414-55.025a6.526,6.526,0,0,1,6.375-7.885h74.15Z",
    transform: "translate(-325.149 -196.515)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6541",
    "data-name": "Path 6541",
    d: "M370.4,340v53.012a3.007,3.007,0,0,0,3.02,3.02H386.5a3.007,3.007,0,0,0,3.02-3.02V340Z",
    transform: "translate(-302.122 -167.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6826",
    "data-name": "Group 6826",
    transform: "translate(4.362 289.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6824",
    "data-name": "Group 6824",
    transform: "translate(135.886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6542",
    "data-name": "Path 6542",
    d: "M413.3,415.4a5.7,5.7,0,1,1,5.7,5.7A5.878,5.878,0,0,1,413.3,415.4Z",
    transform: "translate(-413.3 -409.7)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6543",
    "data-name": "Path 6543",
    d: "M414.9,414.252a2.852,2.852,0,1,1,2.852,2.852A3.066,3.066,0,0,1,414.9,414.252Z",
    transform: "translate(-412.216 -408.548)",
    fill: "#fff",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6825",
    "data-name": "Group 6825"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6544",
    "data-name": "Path 6544",
    d: "M332.3,415.4a5.7,5.7,0,1,1,5.7,5.7A5.878,5.878,0,0,1,332.3,415.4Z",
    transform: "translate(-332.3 -409.7)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6545",
    "data-name": "Path 6545",
    d: "M334,414.252a2.852,2.852,0,1,1,2.852,2.852A2.94,2.94,0,0,1,334,414.252Z",
    transform: "translate(-331.148 -408.548)",
    fill: "#fff",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_6546",
    "data-name": "Path 6546",
    d: "M399.149,422.829V362.1h9.395v60.729c36.4,1.007,58.381,13.589,62.91,16.44a1.762,1.762,0,0,1,.839,1.51v5.033a1.862,1.862,0,0,1-1.845,1.845h0a1.762,1.762,0,0,1-1.51-.839l-2.181-3.858a203.985,203.985,0,0,0-58.213-9.562v9.9a2.293,2.293,0,0,1-2.349,2.349h-4.7a2.293,2.293,0,0,1-2.349-2.349v-9.9a203.983,203.983,0,0,0-58.213,9.562l-2.181,3.858a1.762,1.762,0,0,1-1.51.839h0a1.862,1.862,0,0,1-1.845-1.845V440.78a1.762,1.762,0,0,1,.839-1.51C340.6,436.418,362.745,423.836,399.149,422.829Z",
    transform: "translate(-325.838 -152.064)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6397",
    "data-name": "Rectangle 6397",
    width: 6.207,
    height: 11.24,
    transform: "translate(81.02 301.15) rotate(180)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6398",
    "data-name": "Rectangle 6398",
    width: 19.125,
    height: 21.977,
    transform: "translate(68.278 172.961)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6547",
    "data-name": "Path 6547",
    d: "M329.7,337.987v6.375a3.185,3.185,0,0,0,3.187,3.187H482.194a3.185,3.185,0,0,0,3.187-3.187v-6.375a3.185,3.185,0,0,0-3.187-3.187H332.887A3.3,3.3,0,0,0,329.7,337.987Z",
    transform: "translate(-329.7 -170.563)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6548",
    "data-name": "Path 6548",
    d: "M370.7,407.68h87.068s27.681-45.966,27.681-122.13V257.7a20.907,20.907,0,0,0-20.8-20.8H427.738a20.773,20.773,0,0,0-20.8,20.131C405.762,296.119,400.058,381.006,370.7,407.68Z",
    transform: "translate(-301.918 -236.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6549",
    "data-name": "Path 6549",
    d: "M384.779,407.68h64.085a6.584,6.584,0,0,0,5.872-3.523C461.11,392.078,480.4,349.3,480.4,285.551V257.7a20.8,20.8,0,0,0-20.8-20.8H427.725a20.773,20.773,0,0,0-20.8,20.131c-1.007,35.062-5.7,106.528-27.681,140.248A6.691,6.691,0,0,0,384.779,407.68Z",
    transform: "translate(-296.872 -236.9)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6550",
    "data-name": "Path 6550",
    d: "M329.7,337.987v6.375a3.185,3.185,0,0,0,3.187,3.187h66.936a4.441,4.441,0,0,0,4.362-4.362v-4.026a4.441,4.441,0,0,0-4.362-4.362H332.887A3.3,3.3,0,0,0,329.7,337.987Z",
    transform: "translate(-329.7 -170.563)",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6835",
    "data-name": "Group 6835",
    transform: "translate(351.84 285.208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6834",
    "data-name": "Group 6834",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6833",
    "data-name": "Group 6833"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6832",
    "data-name": "Group 6832",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6831",
    "data-name": "Group 6831",
    transform: "translate(0.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6830",
    "data-name": "Group 6830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6829",
    "data-name": "Group 6829"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6551",
    "data-name": "Path 6551",
    d: "M269.948,242.8l.183-3.114h1.648a1.3,1.3,0,0,1,1.465,1.465,1.108,1.108,0,0,1-.549,1.1,1.546,1.546,0,0,1-1.282.366l-1.465.183m1.832-4.4h-3.114l-.366,8.975h1.465l.183-3.48H271.6l1.648,3.48h1.648l-1.832-3.846a3.286,3.286,0,0,0,1.282-.916,2.08,2.08,0,0,0,.549-1.465,2.5,2.5,0,0,0-.733-2.015,3.681,3.681,0,0,0-2.381-.733",
    transform: "translate(-268.3 -238.217)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6552",
    "data-name": "Path 6552",
    d: "M273.865,242.531a1.663,1.663,0,0,1,.549-1.282c.183-.366.549-.366.916-.366a1.4,1.4,0,0,1,.916.366,1.548,1.548,0,0,1,.366,1.1v.183h-2.747m1.465-2.931a3.451,3.451,0,0,0-1.465.366,2.463,2.463,0,0,0-1.1,1.282,5.418,5.418,0,0,0-.366,1.832v.183a3.378,3.378,0,0,0,.733,2.381,3.033,3.033,0,0,0,2.2.916,3.45,3.45,0,0,0,1.465-.366,4.858,4.858,0,0,0,1.1-.916l-.733-.733a1.924,1.924,0,0,1-1.648.916,1.107,1.107,0,0,1-1.1-.549,1.663,1.663,0,0,1-.549-1.282h4.213v-.549a5.319,5.319,0,0,0-.549-2.564,3.033,3.033,0,0,0-2.2-.916",
    transform: "translate(-264.89 -237.219)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6553",
    "data-name": "Path 6553",
    d: "M278.831,245.461a1.108,1.108,0,0,1-1.1-.549,3.657,3.657,0,0,1-.366-1.648,3.1,3.1,0,0,1,.549-1.832,1.583,1.583,0,0,1,1.1-.549,1.226,1.226,0,0,1,1.282.733l-.183,2.931a1.377,1.377,0,0,1-1.282.916m-.183-5.861a2.941,2.941,0,0,0-2.015.916,3.581,3.581,0,0,0-.733,2.564,4.851,4.851,0,0,0,.549,2.564,2.543,2.543,0,0,0,1.832.916,1.785,1.785,0,0,0,1.648-.733v.55a2.647,2.647,0,0,1-.366,1.282,1.346,1.346,0,0,1-1.1.366,1.924,1.924,0,0,1-1.648-.916l-.733.916a1.828,1.828,0,0,0,.916.733,3.45,3.45,0,0,0,1.465.366,2.833,2.833,0,0,0,3.114-2.747l.183-6.594h-1.282v.733a2.021,2.021,0,0,0-1.832-.916",
    transform: "translate(-261.98 -237.219)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6554",
    "data-name": "Path 6554",
    d: "M281.548,240.864h-1.465l-.183,6.777h1.465l.183-6.777M281,238.3c-.183,0-.549,0-.549.183a.735.735,0,0,0,.549,1.282c.183,0,.549,0,.549-.183a.915.915,0,0,0,0-1.1c-.183,0-.366-.183-.549-.183",
    transform: "translate(-258.654 -238.3)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6555",
    "data-name": "Path 6555",
    d: "M284.247,239.7a3.094,3.094,0,0,0-1.832.549,1.666,1.666,0,0,0-.733,1.465,1.76,1.76,0,0,0,1.1,1.648,2.647,2.647,0,0,0,1.282.366c.549.183.916.183,1.1.366s.366.366.366.549-.183.366-.366.549a1.372,1.372,0,0,1-.916.183,1.271,1.271,0,0,1-1.282-1.1H281.5a1.346,1.346,0,0,0,.366,1.1,1.829,1.829,0,0,0,.916.733,3.451,3.451,0,0,0,1.465.366,2.734,2.734,0,0,0,1.832-.549,1.666,1.666,0,0,0,.733-1.465,1.373,1.373,0,0,0-.183-.916c-.183-.183-.366-.549-.733-.733a8.935,8.935,0,0,0-1.282-.549c-.549-.183-.916-.183-1.1-.366a.673.673,0,0,1-.183-.549c0-.183.183-.55.366-.55a1.1,1.1,0,0,1,.733-.183,1.388,1.388,0,0,1,.733.366.952.952,0,0,1,.366.733h1.465a2.237,2.237,0,0,0-.733-1.648,6.586,6.586,0,0,0-2.015-.366",
    transform: "translate(-257.323 -237.136)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6556",
    "data-name": "Path 6556",
    d: "M287.364,238.9H285.9v1.648h-1.1v1.1h1.1l-.183,3.846c0,1.282.549,2.015,1.648,2.015a1.651,1.651,0,0,0,.916-.183v-1.1h-.549a.673.673,0,0,1-.549-.183c0-.183-.183-.366-.183-.55l.183-3.663h1.1v-1.1h-1.1l.183-1.832",
    transform: "translate(-254.579 -237.801)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6557",
    "data-name": "Path 6557",
    d: "M290.414,239.7a1.508,1.508,0,0,0-1.465.916v-.733h-1.465l-.183,6.777h1.465l.183-4.579c.183-.549.733-.733,1.465-.733h.549v-1.465a.673.673,0,0,0-.549-.183",
    transform: "translate(-252.5 -237.136)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6558",
    "data-name": "Path 6558",
    d: "M291.9,245.561c-.366,0-.549-.183-.733-.183-.183-.183-.183-.366-.183-.733s.183-.549.366-.916a2.647,2.647,0,0,1,1.282-.366h.733v1.282l-.549.549a1.4,1.4,0,0,1-.916.366m.549-5.861a2.716,2.716,0,0,0-1.282.183,1.829,1.829,0,0,0-.916.733,2.6,2.6,0,0,0-.366,1.1h1.465a.951.951,0,0,1,.366-.733,1.372,1.372,0,0,1,.916-.183,1.4,1.4,0,0,1,.916.366,1.373,1.373,0,0,1,.183.916v.366h-.916a3.906,3.906,0,0,0-2.2.549,2.466,2.466,0,0,0-.916,1.648,2.08,2.08,0,0,0,.55,1.465,2.239,2.239,0,0,0,1.648.549,1.785,1.785,0,0,0,1.648-.733.8.8,0,0,0,.183.549h1.465v-.183a3.57,3.57,0,0,1-.183-1.465l.183-3.114a1.786,1.786,0,0,0-.733-1.648,7.789,7.789,0,0,0-2.015-.366",
    transform: "translate(-250.504 -237.136)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6559",
    "data-name": "Path 6559",
    d: "M295.564,238.9H294.1v1.648H293v1.1h1.1l-.183,3.846c0,1.282.549,2.015,1.648,2.015a1.651,1.651,0,0,0,.916-.183v-1.1h-.549a.673.673,0,0,1-.549-.183c0-.183-.183-.366-.183-.55l.183-3.663h1.1v-1.1h-1.1l.183-1.832",
    transform: "translate(-247.76 -237.801)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6560",
    "data-name": "Path 6560",
    d: "M297.248,240.964h-1.465l-.183,6.777h1.465l.183-6.777m-.733-2.564c-.183,0-.549,0-.549.183a.735.735,0,0,0,.549,1.282c.183,0,.549,0,.549-.183a.916.916,0,0,0,0-1.1c0-.183-.183-.183-.549-.183",
    transform: "translate(-245.598 -238.217)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6561",
    "data-name": "Path 6561",
    d: "M299.947,245.561a1.108,1.108,0,0,1-1.1-.55,3.657,3.657,0,0,1-.366-1.648,2.735,2.735,0,0,1,.549-1.832,1.583,1.583,0,0,1,1.1-.549,1.305,1.305,0,0,1,1.1.549,3.656,3.656,0,0,1,.366,1.648,3.094,3.094,0,0,1-.549,1.832,1.108,1.108,0,0,1-1.1.55m.366-5.861a5.349,5.349,0,0,0-1.648.366,2.463,2.463,0,0,0-1.1,1.282,5.419,5.419,0,0,0-.366,1.832h0a3.876,3.876,0,0,0,.733,2.564,3.033,3.033,0,0,0,2.2.916,5.349,5.349,0,0,0,1.648-.366,2.463,2.463,0,0,0,1.1-1.282,5.419,5.419,0,0,0,.366-1.832v-.366a2.627,2.627,0,0,0-2.931-3.114",
    transform: "translate(-244.267 -237.136)",
    fill: "#242424"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6562",
    "data-name": "Path 6562",
    d: "M304.58,239.8a2.254,2.254,0,0,0-1.832.916v-.733h-1.465l-.183,6.777h1.465l.183-4.762c.366-.549.733-.916,1.282-.916a1.4,1.4,0,0,1,.916.366,1.373,1.373,0,0,1,.183.916l-.183,4.4h1.465l.183-4.4c0-1.832-.733-2.564-2.015-2.564",
    transform: "translate(-241.024 -237.053)",
    fill: "#242424"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6842",
    "data-name": "Group 6842",
    transform: "translate(350.073 304.926)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6841",
    "data-name": "Group 6841",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6840",
    "data-name": "Group 6840"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6839",
    "data-name": "Group 6839",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6838",
    "data-name": "Group 6838",
    transform: "translate(0.183 0.183)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6837",
    "data-name": "Group 6837"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6836",
    "data-name": "Group 6836"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6564",
    "data-name": "Path 6564",
    d: "M339.6,249.8H268.9a2.227,2.227,0,0,0-2.2,2.2,2.116,2.116,0,0,0,2.2,2.2h70.7a2.227,2.227,0,0,0,2.2-2.2,2.116,2.116,0,0,0-2.2-2.2",
    transform: "translate(-266.7 -249.8)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6849",
    "data-name": "Group 6849",
    transform: "translate(350.988 313.9)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6848",
    "data-name": "Group 6848",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6847",
    "data-name": "Group 6847"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6846",
    "data-name": "Group 6846",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6845",
    "data-name": "Group 6845",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6844",
    "data-name": "Group 6844"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6843",
    "data-name": "Group 6843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6565",
    "data-name": "Path 6565",
    d: "M302.449,254.6H269.3a2.116,2.116,0,0,0-2.2,2.2,2.227,2.227,0,0,0,2.2,2.2h33.152a2.227,2.227,0,0,0,2.2-2.2,2.021,2.021,0,0,0-2.2-2.2",
    transform: "translate(-267.1 -254.6)"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6856",
    "data-name": "Group 6856",
    transform: "translate(351.721 323.242)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6855",
    "data-name": "Group 6855",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6854",
    "data-name": "Group 6854"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6853",
    "data-name": "Group 6853",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6851",
    "data-name": "Group 6851"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6850",
    "data-name": "Group 6850"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6566",
    "data-name": "Path 6566",
    d: "M317.868,259.7H269.7a2.227,2.227,0,0,0-2.2,2.2,2.116,2.116,0,0,0,2.2,2.2h48.171a2.2,2.2,0,1,0,0-4.4",
    transform: "translate(-267.5 -259.7)"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6857",
    "data-name": "Group 6857",
    transform: "translate(628.926 312.207)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2967",
    "data-name": "Ellipse 2967",
    cx: 16,
    cy: 16.5,
    rx: 16,
    ry: 16.5,
    transform: "translate(0.074 -0.207)",
    fill: "rgba(154,154,154,0.2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Octicons",
    transform: "translate(8.655 7.393)",
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("g", {
    id: "person",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M15.152,17.418a1.26,1.26,0,0,1-1.26,1.26H1.264A1.263,1.263,0,0,1,0,17.414V16.152C0,12.828,5.051,11.1,5.051,11.1a1.556,1.556,0,0,0,0-1.263C3.989,9.056,3.859,7.831,3.788,4.788A3.669,3.669,0,0,1,7.576,1a3.668,3.668,0,0,1,3.788,3.788c-.071,3.043-.2,4.268-1.263,5.051a1.558,1.558,0,0,0,0,1.263s5.051,1.726,5.051,5.051Z",
    transform: "translate(0 -1)",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_6858",
    "data-name": "Group 6858",
    transform: "translate(588.672 372.588)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6403",
    "data-name": "Rectangle 6403",
    width: 113,
    height: 6,
    rx: 3,
    transform: "translate(0.328 0.412)",
    fill: "#36c96d",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6407",
    "data-name": "Rectangle 6407",
    width: 113,
    height: 6,
    rx: 3,
    transform: "translate(0.328 65.412)",
    fill: "#e1f7e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6404",
    "data-name": "Rectangle 6404",
    width: 72,
    height: 6,
    rx: 3,
    transform: "translate(0.328 16.412)",
    fill: "#e1f7e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6406",
    "data-name": "Rectangle 6406",
    width: 65,
    height: 6,
    rx: 3,
    transform: "translate(0.328 48.412)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6405",
    "data-name": "Rectangle 6405",
    width: 34,
    height: 6,
    rx: 3,
    transform: "translate(0.328 32.412)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6408",
    "data-name": "Rectangle 6408",
    width: 35,
    height: 6,
    rx: 3,
    transform: "translate(46.328 32.412)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6409",
    "data-name": "Rectangle 6409",
    width: 17,
    height: 6,
    rx: 3,
    transform: "translate(73.328 48.412)",
    fill: "#ebebeb"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg4);
export default __webpack_public_path__ + "static/media/img4.0eecc4b4ea2e89a5ef8007099b033b41.svg";
export { ForwardRef as ReactComponent };